import React, { useEffect } from "react";
import Gallery from "scenes/homePage/gallery/Gallery";
import { importAll } from "utils/loadGalleryImages";
import "../homePage/HomePage.css";

// Dynamically import all images from folder
const galleryImages = importAll(
  require.context("../../assets/gallery", false, /\.(png|jpe?g|webp)$/)
);

const GalleryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="gallery-section">
      <h1 className="gallery-title">Galerie d'images</h1>
      <Gallery images={galleryImages} partial />
    </section>
  );
};

export default GalleryPage;
